<template>
    <div>
        <b-modal
            ref="new-calculations-request-modal"
            v-model="modalShow"
            :no-close-on-backdrop="true"
            :hide-header-close="true"
            :no-close-on-esc="true"
            :hide-footer="true"
            title="New calculations request"
            centered
            size="lg"
            justify="center"
            persistent
        >
            <div class="modal-content  border-0 p-0">
                <div class="modal-body">
                    <br />
                    <div class="col-12 form-group text-center p-4">
                        Email Address

                        <div
                            class="d-flex form-group justify-content-center row-2 pt-2"
                        >
                            <input
                                v-model="pdfData.email"
                                type="text"
                                class="form-control"
                                dir="auto"
                                placeholder="Type email address where the pdfs would be sent"
                            />
                        </div>
                        <br />
                        <div class="custom-modal-text text-left">
                            <label :for="customRef">
                                Upload .idf file to modify
                            </label>
                            <vue-dropzone
                                :id="customRef"
                                :ref="customRef"
                                :options="{
                                    ...dropzoneOptions,
                                    url: apiUrl + dropzoneRelativePath
                                }"
                                class="h-100 d-flex justify-content-center align-items-center flex-wrap"
                                @vdropzone-sending="sendingFile"
                                @vdropzone-queue-complete="queueComplete"
                            />
                        </div>
                        <div class="pt-3">
                            <label> Report writer name</label>
                            <input
                                v-model="pdfData.writerName"
                                type="text"
                                class="form-control"
                                dir="auto"
                            />
                        </div>
                        <br />
                        <div>
                            <label> Phone number </label>
                            <input
                                v-model="pdfData.phoneNumber"
                                type="text"
                                class="form-control"
                                dir="auto"
                            />
                            <br />
                        </div>
                    </div>
                </div>

                <div class="modal-footer p-4 d-block " style="">
                    <div style="float:left;">
                        <button
                            class="btn pl-5 pr-5 btn-success waves-effect waves-light"
                            data-animation="fadein"
                            data-overlaycolor="#38414a"
                            @click="uploadFiles(customRef)"
                        >
                            Save
                        </button>
                    </div>
                    <div style=" float:right;">
                        <button
                            class="btn pl-5 pr-5 btn-danger waves-effect waves-light"
                            data-animation="fadein"
                            data-overlaycolor="#38414a"
                            @click="onClose"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>

            <div></div>
        </b-modal>
    </div>
</template>

<script>
import config from '@/config';
import { mapActions, mapGetters } from 'vuex';
import vueDropzone from 'vue2-dropzone';

export default {
    components: {
        vueDropzone
    },

    props: {
        modalShow: Boolean,
        projectData: {
            type: Object,
            default: () => {}
        }
    },

    page: {
        title: 'Greener - Calculations Requests'
    },

    data() {
        return {
            pdfData: {
                email: '',
                climate: '',
                companyName: '',
                writerName: '',
                phoneNumber: '',
                projectName: '',
                address: '',
                plot: '',
                block: '',
                uValueOfWallBridge: 2,
                wallBridgePercentage: 10,
                massPerUnit: null
            },
            energyPlusVersion: '',
            greenerVersion: '',
            designBuilderVersion: '',
            dropzoneRelativePath: '/calculations-requests',
            apiUrl: config.apiUrl
        };
    },

    computed: {
        ...mapGetters({ getByKey: 'settings/getByKey' }),

        dropzoneOptions() {
            const options = {
                thumbnailWidth: 150,
                maxFilesize: 200,
                timeout: 120000,
                uploadMultiple: false,
                acceptedFiles: '.idf',
                dictDefaultMessage: `Click Here </br> or </br> Drop idf File <i class='fe-upload'></i>`,
                addRemoveLinks: true,
                duplicateCheck: true,
                withCredentials: true,
                autoProcessQueue: false,
                parallelUploads: 100
            };

            return options;
        },

        customRef() {
            return (
                Math.random()
                    .toString(36)
                    .substring(2, 30)
                    .match(/[a-zA-Z]+/g)
                    .join('') + 'FileDropzone'
            );
        }
    },

    watch: {
        projectData() {
            if (!this.projectData) return;

            this.pdfData = {
                ...{
                    climate: this.projectData.climate,
                    companyName: this.projectData.companyName,
                    projectName: this.projectData.name,
                    address: this.projectData.address,
                    plot: this.projectData.plot,
                    block: this.projectData.block,
                    uValueOfWallBridge: this.projectData.uValueOfWallBridge,
                    wallBridgePercentage: this.projectData.wallBridgePercentage,
                    massPerUnit: this.projectData.massPerUnit
                }
            };
        }
    },

    async created() {
        await this.getSettings();

        this.energyPlusVersion = this.getByKey('energy_plus');

        this.designBuilderVersion = this.getByKey('design_builder');

        this.greenerVersion = this.getByKey('greener_version');
    },

    methods: {
        ...mapActions({
            getSettings: 'settings/index'
        }),

        async uploadFiles(dropZoneRef) {
            this.$refs[dropZoneRef].processQueue();
        },

        onClose() {
            this.$emit('close');
        },

        queueComplete() {
            this.$emit('getRequests');

            this.$bvToast.toast('Idf has been uploaded.', {
                title: 'Success!',
                variant: 'success',
                solid: true
            });

            this.$bvToast.toast('New idf file has been created.', {
                title: 'Modified and Created!',
                variant: 'success',
                solid: true
            });

            this.$refs[this.customRef].removeAllFiles();
            this.onClose();
        },

        async sendingFile(file, xhr, formData) {
            formData.append('climate', this.projectData.climate);
            formData.append('weatherFile', this.projectData.weatherFile);
            formData.append('isSettingFile', false);
            formData.append('projectId', this.projectData.id);
            formData.append('userEmail', this.pdfData.email);
            formData.append('type', this.projectData.surfaceTypeToRate);
            formData.append(
                'pdfData',
                JSON.stringify({
                    ...this.pdfData,
                    ...{
                        energyPlusVersion: this.energyPlusVersion,
                        designBuilderVersion: this.designBuilderVersion,
                        greenerVersion: this.greenerVersion
                    }
                })
            );

            xhr.setRequestHeader(
                'cluid',
                JSON.parse(window.localStorage.getItem('auth.currentUser')).id
            );

            return formData;
        }
    }
};
</script>

<style>
.modal-body {
    padding: 0;
}
</style>
